import { Router } from 'src/routes/router';
import { useDocumentLang } from 'src/hooks/use-document-lang';
import { ConsentBanner } from 'src/components/cookie-consent/consent-banner';
import { ConsentProvider } from 'src/components/cookie-consent/consent-context';

export function App() {
  useDocumentLang();

  return (
    <ConsentProvider>
      <Router />
      <ConsentBanner />
    </ConsentProvider>
  );
}
